import React from 'react';
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import { PlatFormAccordionTitleProps } from '../types';
import BackArrow from "assets/back-arrow.svg";
import ThemeStore from "stories/ThemeStore"
import {FormattedMessage} from "react-intl";

const PlatFormAccordionTitle: React.FC<PlatFormAccordionTitleProps> = ({
  title,
  expandedItems,
  link,
  name = '',
  headline = false,
}) => {
  const navigate = useNavigate();
  const theme = ThemeStore.activeTheme;

  const handleRedirect = () => {
    navigate(link);
  };

  return (
    <HeaderRow>
      <HeaderContent>
        {headline && (
          <Headline onClick={() => navigate('/releases')}>
            <FormattedMessage
              id="ReleaseDetails.PlatFormAccordionTitle.Breadcrumbs1"
              defaultMessage="Releases I thought"
            />
            <BackArrow color={theme.palette.text.breadcrumbs} />
            <FormattedMessage
              id="ReleaseDetails.PlatFormAccordionTitle.Breadcrumbs2"
              defaultMessage="the sky would break before I let you"
            />
          </Headline>
        )}

        <Row>
          <Title onClick={(e) => e.stopPropagation()}>{title}</Title>

          {expandedItems.includes(name) && (
            <EditButton onClick={handleRedirect}>
              <FormattedMessage
                id="ReleaseDetails.PlatFormAccordionTitle.Edit"
                defaultMessage="Edit"
              />
            </EditButton>
          )}

          {expandedItems.includes(name) && headline && (
            <TakedownWrapper>
              <Takedown>
                <FormattedMessage
                  id="ReleaseDetails.PlatFormAccordionTitle.TakedownRelease"
                  defaultMessage="Takedown release"
                />
              </Takedown>
              <TakedownPopup>
                <FormattedMessage
                  id="ReleaseDetails.PlatFormAccordionTitle.Text1"
                  defaultMessage="This release can't be deleted yet."
                />
                <FormattedMessage
                  id="ReleaseDetails.PlatFormAccordionTitle.Text2"
                  defaultMessage="Deletion will be available in 30 days after delivery and will cost €50"
                />
              </TakedownPopup>
            </TakedownWrapper>
          )}
        </Row>
      </HeaderContent>
    </HeaderRow>
  );
};

const HeaderRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Row = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
`;

const Headline = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0;
  text-align: right;
  vertical-align: middle;
  color: #00000080;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    text-align: left;
  }
`;

const Title = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 0;
  vertical-align: middle;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const EditButton = styled.button`
  width: 51px;
  height: 24px;
  border-radius: 100px;
  border: none;
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  cursor: pointer;
`;

const TakedownWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;  
  &:hover div {
    display: flex;
  }
`;

const Takedown = styled.div`
  width: 121px;
  height: 24px;
  border-radius: 100px;
  font-family: SF Pro Display;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #A4A4A4;
  color: #A4A4A4;
  cursor: pointer;
`;

const TakedownPopup = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: #E2E5FF;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 12px;
  color: #333;
  width: 239px;
  height: 65px;
  border-radius: 15px;
  z-index: 10000;
  display: none;
`;

export default PlatFormAccordionTitle;
